import { css } from 'lit';

export const serversPageStyles = css`
  .inline {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-2);
  }

  .inline input {
    flex: 1 1 var(--inline-field-min-width);
    width: auto;
  }

  .create {
    max-width: var(--form-width-md);
    margin-top: var(--column-gap);
  }

  .request {
    margin-bottom: var(--space-3);
  }

  .request form {
    margin-top: var(--space-3);
    align-items: center;
  }

  .check {
    display: flex;
    flex: 1 1 100%;
    align-items: center;
    gap: var(--space-2);
  }

  .inline .check input {
    flex: none;
    width: auto;
  }
`;
